const createTemplateMixpanel = (currentTemplate, user, presetTemplateUsed)  => {
   return {
      type: 'ADD_TEMPLATE_MIXPANEL',
      payload: currentTemplate,
      meta: {
        mixpanel: {
           event: 'addTemplate',
           props: {
             sentFrom: "web",
             templateId: currentTemplate.objectId,
             templateName: currentTemplate.name,
             userId: currentTemplate.userId,
             userName: user.nickName,
             presetTemplateName: presetTemplateUsed ? presetTemplateUsed.name : "none",
             presetTemplateId: presetTemplateUsed ? presetTemplateUsed.id : "none",

           }
        }
      }
   }
}

export default createTemplateMixpanel;



// WEBPACK FOOTER //
// ./src/actions/mixpanel/createTemplateMixpanel.js